import { render } from "./TheFooter.vue?vue&type=template&id=33754878&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=33754878&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33754878"

export default script